import React from "react";
import { motion } from "framer-motion";
import AuctionCategoriesSection from "./SecuritySection/AuctionCategoriesSection";
import CTACallSection from "./SecuritySection/CTACallSection";
import CarValuationSection from "./SecuritySection/CarValuationSection";
import { RegistrationInputButton } from "../valuation/RegistrationInputButton";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface SecuritySectionProps {
  onValuationClick: () => void;
}

const SecuritySection = ({ onValuationClick }: SecuritySectionProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.buyCar?.securitySection || {};

  return (
    <section className="py-16 md:py-20 relative overflow-hidden text-gray-900">
      {/* White background */}
      <div className="absolute inset-0 bg-white" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
            {sectionData.title || "Kommande Auktioner"}
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            {sectionData.description ||
              "Upptäck våra auktionskategorier och hitta ditt nästa fordon."}
          </p>
        </motion.div>

        <AuctionCategoriesSection />
        <CTACallSection />
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-12 md:mt-16 max-w-2xl mx-auto px-4"
        >
          <div className="bg-gradient-to-r from-emerald-600 to-cyan-600 rounded-xl md:rounded-2xl p-4 md:p-6">
            <h3 className="text-xl text-center md:text-2xl text-white font-bold mb-2 md:mb-3">
              {sectionData.ctaTitle || "Redo att Sälja Din Bil?"}
            </h3>
            <p className="text-base text-center md:text-lg text-white mb-4 md:mb-8 opacity-90 max-w-xl mx-auto">
              {sectionData.ctaDescription ||
                "Starta processen idag och få din bil såld på kortast möjliga tid"}
            </p>

            <RegistrationInputButton onClick={onValuationClick} />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SecuritySection;
